import { gql } from "graphql-request";

/**
 * The fields every link selection needs.
 *
 * In its own module rather than alongside the mutations, because four owners'
 * queries import it — and a fragment living next to one owner's query would make
 * that owner look special when it is not.
 *
 * No `sortOrder`: the server returns the list already ordered, so there is
 * nothing for a client to sort by.
 */
export const LINK_FIELDS = gql`
  fragment LinkFields on Link {
    id
    url
    label
    kind
    isPrimary
  }
`;
